import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import type { MediaTextBlock } from '../types';
import { DescriptionBlocks } from '../DescriptionBlocks';
import styles from './MediaText.module.css';
interface MediaTextProps {
  block: MediaTextBlock;
  blockId: string;
}
export function MediaText(t0) {
  const $ = _c(28);
  const {
    block,
    blockId
  } = t0;
  const mediaFirst = block.mediaPosition !== "right";
  const isJumbotronVideo = block.variant === "jumbotronVideo" || isVideoListingIntro(block);
  const t1 = isJumbotronVideo ? styles.jumbotronVideo : null;
  const t2 = block.ratio === "twoThirdsContent" ? styles.twoThirdsContent : null;
  const t3 = block.ratio === "threeQuartersContent" ? styles.threeQuartersContent : null;
  const t4 = block.ratio === "twoThirdsMedia" ? styles.twoThirdsMedia : null;
  const t5 = block.ratio === "threeQuartersMedia" ? styles.threeQuartersMedia : null;
  const t6 = block.ratio === "sevenTwelfthsMedia" ? styles.sevenTwelfthsMedia : null;
  const t7 = block.ratio === "fiveSixthsContent" ? styles.fiveSixthsContent : null;
  const t8 = block.variant === "birdeyePhoneRow" ? styles.birdeyePhoneRow : null;
  const t9 = block.spacing === "compact" ? styles.compact : null;
  const t10 = block.spacing === "none" ? styles.noSpacing : null;
  let t11;
  if ($[0] !== t1 || $[1] !== t10 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
    t11 = [styles.row, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10].filter(Boolean);
    $[0] = t1;
    $[1] = t10;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const className = t11.join(" ");
  const t12 = `${blockId}.media`;
  let t13;
  if ($[11] !== block.media || $[12] !== t12) {
    t13 = <div className={styles.media}><DescriptionBlocks blocks={block.media} blockIdPrefix={t12} /></div>;
    $[11] = block.media;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  const media = t13;
  let t14;
  if ($[14] !== block.eyebrow) {
    t14 = block.eyebrow ? <span className={styles.eyebrow}>{block.eyebrow}</span> : null;
    $[14] = block.eyebrow;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const t15 = `${blockId}.content`;
  let t16;
  if ($[16] !== block.content || $[17] !== t15) {
    t16 = <DescriptionBlocks blocks={block.content} blockIdPrefix={t15} />;
    $[16] = block.content;
    $[17] = t15;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t14 || $[20] !== t16) {
    t17 = <div className={styles.content}>{t14}{t16}</div>;
    $[19] = t14;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  const content = t17;
  const t18 = block.mediaPosition ?? "left";
  const t19 = mediaFirst ? media : content;
  const t20 = mediaFirst ? content : media;
  let t21;
  if ($[22] !== blockId || $[23] !== className || $[24] !== t18 || $[25] !== t19 || $[26] !== t20) {
    t21 = <section className={className} data-cms-block-id={blockId} data-cms-field="mediaText" data-media-position={t18}>{t19}{t20}</section>;
    $[22] = blockId;
    $[23] = className;
    $[24] = t18;
    $[25] = t19;
    $[26] = t20;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  return t21;
}
function isVideoListingIntro(block: MediaTextBlock): boolean {
  const hasVideo = block.media.some(mediaBlock => mediaBlock.kind === 'video');
  const hasListingTitle = block.content.some(contentBlock => contentBlock.kind === 'heading' && contentBlock.variant === 'listingTitle');
  return hasVideo && hasListingTitle;
}